export class Dashboard {
    static readonly GET_REPORTS_FOR_USER_BY_CURRENT_TOKEN =
        '/api/Dashboard/httpGet_GetReportsForUserByCurrentToken';
    static readonly GET_REPORT_DATA_FOR_USER_BY_CURRENT_TOKEN =
        '/api/Dashboard/httpGet_GetReportDataForUserByCurrentToken';
    static readonly GET_REPORT_FILE_FOR_USER_BY_CURRENT_TOKEN =
        '/api/Dashboard/httpGet_GetReportFileforUserByCurrentToken';
    static readonly RESET_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN =
        '/api/Dashboard/httpPost_ResetCustomizationForReportItemByCurrentToken';
    static readonly UPDATE_CUSTOMIZATION_FOR_REPORT_ITEM_BY_CURRENT_TOKEN =
        '/api/Dashboard/httpPost_UpdateCustomizationForReportItemByCurrentToken';
}

export default Dashboard;
